import styled from "styled-components";
import { PlainTextStyle } from "../../styled";

export const SectionOurProducts = styled.section`
    padding-bottom: 150px;
`;

export const AboutContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
`;

export const AboutTitle = styled.h2`
    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const AboutCards = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 30px;
    @media (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
    }
`;

export const AboutCard = styled.div`
    background: #fff;
    border-radius: 35px;
    padding: 50px;
    width: 30%;
    min-height: 250px;
    transform: scale(1);
    transition: 0.25s transform linear;
    font-size: 30px;
    &:hover {
        transform: scale(1.1);
    }
    @media (max-width: 1199px) {
        padding: calc(35px + (15) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 767px) {
        width: 47%;
    }
    @media (max-width: 599px) {
        min-height: 150px;
        width: 95%;
    }
    @media (max-width: 424px) {
        width: 100%;
    }
`;

export const AboutCardText = styled.div`
    ${PlainTextStyle}
    line-height: 1.4;
    font-style: normal;
`;
